export default "__VITE_ASSET__BsD_fRDc__"